<template>
    <v-container>
      <v-row>
          <v-col cols="12">
            <div class="text-left" style="margin-bottom:20px;">
                <router-link to="/">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                </router-link>
              </div>                  
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h1>Las Vegas</h1>
        </v-col>
      </v-row>
      


      <h2 class="text-left">October</h2>
      <div class="text-left">October 14th Sydney to Las Vegas</div>
      <div class="text-left">October 14h Planet Hollywood</div>
      <v-row style="margin-top:10px;">
        <v-col cols="12" class="text-left">
          <a href="https://www.thesphere.com/shows/unity" target="_blank">

              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-bottom:15px;"
              >
                Sphere - Insoniac X Tomorrowland 17th October 11:15pm
              </v-btn>
          </a>
        </v-col>
      </v-row>      
      <div style="margin-top:30px;"></div>
      <div class="text-left">October 18th Virgin Hotel</div>
      <div style="margin-top:30px;"></div>
      <div class="text-left">October 21 Vdara</div>
      <div style="margin-top:30px;"></div>
      <div class="text-left">October 25 Palazzo</div>
      <div class="text-left">October 27 Las Vegas to Sydney</div>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>